var map = {
	"./1000+.png": 162,
	"./404.png": 163,
	"./BookReader.png": 164,
	"./Booknet.png": 165,
	"./BravoFiction.png": 166,
	"./CamelNovel.png": 167,
	"./Chapters.png": 168,
	"./CoralReader.png": 169,
	"./CornReading.png": 170,
	"./DailyBooks.png": 171,
	"./DeerFiction.png": 172,
	"./DolphinReader.png": 173,
	"./Dreams.png": 174,
	"./FICTLF.png": 175,
	"./FancyNovel.png": 176,
	"./FicFun.png": 177,
	"./FictionFlow.png": 178,
	"./FoxFics.png": 179,
	"./FoxFm.png": 180,
	"./Free2Read.png": 181,
	"./FreeRead.png": 182,
	"./FunFic.png": 183,
	"./FunNovel.png": 184,
	"./Gonovel.png": 185,
	"./GoodFiction.png": 186,
	"./GoodStory.png": 187,
	"./GoodToon.png": 188,
	"./GrapeNovel.png": 189,
	"./HippoNovel.png": 190,
	"./HitNovel.png": 191,
	"./HotNovel.png": 192,
	"./IHear.png": 193,
	"./Inkspired.png": 194,
	"./Inkwell.png": 195,
	"./KiWiReader.png": 196,
	"./Kiwi.png": 197,
	"./LemonRead.png": 198,
	"./LetsRead.png": 199,
	"./Libfic.png": 200,
	"./Liby.png": 201,
	"./LionFiction.png": 202,
	"./Listenow.png": 203,
	"./LoveNovel.png": 204,
	"./LoveRead.png": 205,
	"./Mango.png": 206,
	"./MangoReader.png": 207,
	"./Mebooks.png": 208,
	"./Mobooks.png": 209,
	"./Monkey.png": 210,
	"./MyNovel.png": 211,
	"./NovelFox.png": 212,
	"./NovelNow.png": 213,
	"./NovelPro.png": 214,
	"./NovelWorld.png": 215,
	"./NovelZone.png": 216,
	"./Octopus.png": 217,
	"./OrangeReader.png": 218,
	"./OwlReader.png": 219,
	"./PocketFic.png": 220,
	"./PocketeBooks.png": 221,
	"./PocketeReader.png": 222,
	"./Pocketoons.png": 223,
	"./Podfic.png": 224,
	"./PopFic.png": 225,
	"./PopNovel.png": 226,
	"./PopStories.png": 227,
	"./Pumpkin.png": 228,
	"./Rabbit.png": 229,
	"./Read4Fun-ios.png": 230,
	"./Read4Fun.png": 231,
	"./ReadNow.png": 232,
	"./Readify.png": 233,
	"./Readme.png": 234,
	"./Seagull.png": 235,
	"./Sealread.png": 236,
	"./SharkNovels.png": 237,
	"./Shepherd.png": 238,
	"./SnailReads.png": 239,
	"./StarfishFiction.png": 240,
	"./StoryHouse.png": 241,
	"./StoryRover.png": 242,
	"./StorySphere.png": 243,
	"./StorySpot.png": 244,
	"./SuperFiction.png": 245,
	"./SuperNovel.png": 246,
	"./Sweet.png": 247,
	"./TaleTrek.png": 248,
	"./TapRead.png": 249,
	"./Tellstory.png": 250,
	"./TigerReader.png": 251,
	"./Tomato.png": 252,
	"./TopFic.png": 253,
	"./Topicks.png": 254,
	"./VampireNovels.png": 255,
	"./WeJoy.png": 256,
	"./WeRead.png": 257,
	"./Webfiction.png": 258,
	"./Webfm.png": 259,
	"./Webnovel.png": 260,
	"./Webstories.png": 261,
	"./Whatstory.png": 262,
	"./about_bg.png": 263,
	"./android-FicFun.png": 264,
	"./appStore-check.png": 265,
	"./appStore.png": 56,
	"./app_logo.png": 120,
	"./application.png": 266,
	"./banner.png": 267,
	"./banner1.png": 268,
	"./banner2.png": 269,
	"./banner3.png": 270,
	"./basic.png": 271,
	"./bg-game.png": 272,
	"./bg.png": 273,
	"./book.png": 274,
	"./bottom-icon.png": 275,
	"./cherryfiction.png": 276,
	"./close.png": 277,
	"./contact_bg.png": 278,
	"./desc.png": 279,
	"./down (1).png": 280,
	"./down.png": 281,
	"./e1.png": 282,
	"./e2.png": 283,
	"./e3.png": 284,
	"./eAudioBooks.png": 285,
	"./eReader-logo.png": 286,
	"./ereader.png": 287,
	"./ficfun-logo.png": 288,
	"./fj.png": 289,
	"./form_bg.png": 290,
	"./funtel-logo.png": 291,
	"./funtel.png": 292,
	"./goodfic.png": 293,
	"./googlePlay-check.png": 294,
	"./googlePlay.png": 57,
	"./greatnovel.png": 295,
	"./i1.png": 296,
	"./i2.png": 297,
	"./i3.png": 298,
	"./iAudios.png": 299,
	"./iComics.png": 300,
	"./iNovel-ios.png": 301,
	"./iNovel.png": 302,
	"./iRomance.png": 303,
	"./iToons.png": 304,
	"./icon.png": 305,
	"./infinitytale.png": 306,
	"./iosGoodStory.png": 307,
	"./iosgoodfiction.png": 308,
	"./left.png": 309,
	"./litchifiction.png": 310,
	"./logo.png": 311,
	"./logo2.png": 312,
	"./logo3.png": 313,
	"./logo4.png": 314,
	"./logo5.png": 315,
	"./m-tel.png": 316,
	"./more.png": 317,
	"./pandareads.png": 318,
	"./peanutnovel.png": 319,
	"./phone.png": 121,
	"./pocketEbook.png": 320,
	"./qiandao.png": 321,
	"./redfic.png": 322,
	"./right.png": 323,
	"./right_bg.png": 324,
	"./romancestories.png": 325,
	"./storyfm.png": 326,
	"./theme3/shu.png": 122,
	"./theme4/banner.png": 123,
	"./theme4/people.png": 124,
	"./topstories.png": 327,
	"./ty.png": 328,
	"./web-logo.png": 329,
	"./werewolfnovels.png": 330,
	"./whatsread.png": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;